export default __webpack_public_path__ + "static/media/2018 (5).4dc1f413.jpg";